import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { FONT_STACK } from '../constants/fontface.constant';

export const MuiTab = (baseTheme: Theme): Partial<Components> => ({
  MuiTab: {
    styleOverrides: {
      root: {
        minHeight: '38px',
        minWidth: '40px',
        transition: 'color .01s',
        padding: '0',
        marginInlineEnd: '32px',
        '&:hover, &:focus-visible': {
          color: baseTheme.palette.brand.main,
        },
        '&.MuiTab-textColorPrimary.Mui-selected': {
          color: baseTheme.palette.brand.main,
          '& svg path': {
            fill: baseTheme.palette.brand.main,
          },
        },
        '&.MuiTab-textColorPrimary': {
          fontWeight: '500',
          fontFamily: FONT_STACK,
          color: baseTheme.new.color.textPrimary,
          '&:hover, &:focus-visible': {
            color: baseTheme.palette.brand.main,
            '& svg path': {
              fill: baseTheme.palette.brand.main,
            },
          },
          '& svg path': {
            fill: baseTheme.new.color.textPrimary,
          },
        },
        textTransform: 'none',
        display: 'flex',
        flexDirection: 'row',
        '& svg': {
          marginRight: '20px',
        },
        '& .MuiTab-iconWrapper': {
          marginBottom: '0px',
        },
      },
    },
  },
});

export const MuiTabs = (baseTheme: Theme): Partial<Components> => ({
  MuiTabs: {
    styleOverrides: {
      root: {
        minHeight: '38px',
        '& span.MuiTabs-indicator': {
          height: '2px',
          backgroundColor: baseTheme.palette.brand.main,
        },
        padding: '0px 10px',
        [baseTheme.breakpoints.up('lg')]: {
          padding: '0',
        },
        '& .MuiButtonBase-root': {
          '&.Mui-disabled': {
            opacity: '0.2',
          },
        },
      },
    },
  },
});
